module.exports = __webpack_public_path__ + "images/db6b8a6b51ca6a8ab9d2ab4c61cbebac-illu_resolution_longRange_DW.png";